import { WEIGHT_UNITS } from '@seedplanner/shared-utils';

interface ContainerSize {
  readonly size: number;
  readonly unit: string;
}

// Group by unit, then sort by size
export function sortContainerSizes<T extends ContainerSize>(sizes: readonly T[]): readonly T[] {
  const sorted = [...sizes];
  sorted.sort((a, b) => {
    if (a.unit === b.unit) {
      return a.size - b.size;
    }
    if (a.unit === WEIGHT_UNITS.OUNCES) {
      return 1;
    }
    if (b.unit === WEIGHT_UNITS.OUNCES) {
      return -1;
    }
    if (a.unit === WEIGHT_UNITS.GRAMS) {
      return 1;
    }
    if (b.unit === WEIGHT_UNITS.GRAMS) {
      return -1;
    }

    return 0;
  });

  return sorted;
}
